module.exports = __webpack_public_path__ + "img/couples_08_V.3dbad808.webp";